<script lang="ts">
    import { Button } from "flowbite-svelte";
    import {
        ChevronDoubleDownOutline,
        ChevronDoubleUpOutline,
        InfoCircleOutline,
        TrashBinOutline,
    } from "flowbite-svelte-icons";
    import CustomAccordion from "../components/CustomAccordion.svelte";
    import CustomIndicatorItem from "../components/CustomIndicatorItem.svelte";
    import GenericAccordionItem from "../components/GenericAccordionItem.svelte";
    import { evaluations, summaries } from "./store";
    import GenericContentViewModal from "../components/GenericContentViewModal.svelte";
    import { createLocalStorageStore, global_state } from "../../service/store";
    import { writable } from "svelte/store";
    import { getNestedDict, updateNestedDict } from "../../service/sse";
    import { toast } from "@zerodevx/svelte-toast";
    import { make_request } from "../../service/http_calls";
    import { onMount } from "svelte";
    export let project_data;
    export let accordion_items_refs = {};
    let indicators_refs = {};
    let is_collapsed = false;

    let project_manual_notes = writable(undefined);

    let meeting_id = createLocalStorageStore(
        "realtime_meeting_id",
        crypto.randomUUID(),
    );
    export function get_current_content() {
        return Object.keys(summaries)
            .map(
                (key) =>
                    `${summaries[key].title}: ${accordion_items_refs[key]?.getContent() ?? ""}`,
            )
            .join("\n\n");
    }

    let content_modal_open = writable(false);
    async function handleSaveNotes(project_id: string) {
        const request_id = crypto.randomUUID();

        await make_request(
            {
                type: "realtime",
                sub_type: "update_project_manual_notes",
                request_id: request_id,
                payload: {
                    project_id: project_id,
                    manual_notes: $project_manual_notes,
                },
            },
            [],
            {},
        );
        toast.push("Notes saved!");
    }
    global_state.subscribe((state) => {
        const manual_notes = getNestedDict(state, [
            "realtime",
            "router",
            "projects",
            "notes",
            project_data.id,
            "data",
        ]);
        project_manual_notes.set(manual_notes ?? "");
    });

    $: {
        if ($project_manual_notes !== undefined) {
            try {
                global_state.update((state) => {
                    updateNestedDict(
                        state,
                        [
                            "realtime",
                            "router",
                            "projects",
                            "notes",
                            project_data.id,
                            "data",
                        ],
                        $project_manual_notes,
                    );
                    return state;
                });
            } catch (e) {
                console.error("Error updating manual notes", e);
            }
        }
    }

    onMount(() => {
        const manual_notes = getNestedDict($global_state, [
            "realtime",
            "router",
            "projects",
            "notes",
            project_data.id,
            "data",
        ]);
        project_manual_notes.set(manual_notes ?? "");
    });
</script>

<!-- <P size="lg" class="my-5 font-bold">
    <Span gradient>Project: {title}</Span>
</P> -->
<div class="flex justify-center">
    <div class="flex gap-2 mb-10">
        {#each Object.entries(evaluations) as [key, evaluation]}
            <CustomIndicatorItem
                title={evaluation.title}
                component_address={[
                    "realtime",
                    "router",
                    "projects",
                    "data",
                    project_data.id,
                    "summary",
                    `${key}`,
                ]}
                bind:this={indicators_refs[key]}
            />
        {/each}
    </div>
</div>
<div class="justify-center flex">
    <Button
        class="mr-3 mb-5 hover:bg-purple-200 rounded-full p-2 bg-transparent"
        title={is_collapsed
            ? "Collapse all accordions"
            : "Expand all accordions"}
        on:click={() => {
            is_collapsed = !is_collapsed;
            for (let [key, accordion_item_ref] of Object.entries(
                accordion_items_refs,
            )) {
                if (is_collapsed) {
                    accordion_item_ref.handleExpand();
                } else {
                    accordion_item_ref.handleCollapse();
                }
            }
        }}
    >
        {#if is_collapsed}
            <ChevronDoubleUpOutline color="grey"></ChevronDoubleUpOutline>
        {:else}
            <ChevronDoubleDownOutline color="grey"></ChevronDoubleDownOutline>
        {/if}
    </Button>

    <Button
        class="mr-3 mb-5 hover:bg-purple-200 rounded-full p-2 bg-transparent"
        title="View transcript"
        on:click={() => {
            content_modal_open.set(true);
        }}
    >
        <svg
            xmlns="http://www.w3.org/2000/svg"
            class="w-5 h-5"
            fill="none"
            viewBox="0 0 24 24"
            stroke="grey"
        >
            <path
                stroke-linecap="round"
                stroke-linejoin="round"
                stroke-width="2"
                d="M9 12h6m-6 4h6m2 5H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z"
            />
        </svg>
    </Button>
</div>
<CustomAccordion>
    {#each Object.keys(summaries) as key}
        <GenericAccordionItem
            bind:this={accordion_items_refs[key]}
            title={summaries[key].title}
            component_address={[
                "realtime",
                "router",
                "projects",
                "data",
                project_data.id,
                "summary",
                key,
            ]}
            override_system_prompt={["realtime", key, "system_prompt"]}
            override_assistant_prompt={["realtime", key, "assistant_prompt"]}
            module_name="realtime"
            must_use_files={false}
            hide_model_selector={true}
            disable_paragraph_regenerate={true}
            no_buttons={true}
            extra_context={writable(
                getNestedDict($global_state, [
                    "realtime",
                    "router",
                    "projects",
                    "data",
                    project_data.id,
                    "summary",
                    key,
                ]) +
                    "\n\nProject Transcript:\n" +
                    (project_data?.minutes
                        ?.map((m) => m.transcript)
                        .join("\n") ?? ""),
            )}
            suppress_notification={true}
            collapsed={false}
            include_fact_check={false}
            include_source_attributions={false}
            custom_icon={"plus"}
            metadata={{
                project_name: project_data.title,
                component: key,
                meeting_id: $meeting_id,
            }}
        ></GenericAccordionItem>
    {/each}
    <div class="mt-4 mb-4">
        <textarea
            bind:value={$project_manual_notes}
            on:blur={async () => {
                await handleSaveNotes(project_data.id);
            }}
            placeholder="Take notes here..."
            class="w-full p-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-purple-500 focus:border-purple-500 min-h-[100px]"
        ></textarea>
    </div>
</CustomAccordion>

<GenericContentViewModal
    title={`Transcript: ${project_data?.title ?? "Unknown Project"}`}
    content={project_data?.minutes
        ?.map((m) => {
            // Format timestamp if it exists
            let formattedTime = "Unknown time";
            if (m.timestamp) {
                try {
                    // Convert timestamp to Date object and format it
                    const date = new Date(m.timestamp);
                    if (!isNaN(date)) {
                        formattedTime = date.toLocaleTimeString([], {
                            hour: "2-digit",
                            minute: "2-digit",
                            second: "2-digit",
                        });
                    }
                } catch (e) {
                    // If parsing fails, use the raw timestamp
                    formattedTime = m.timestamp;
                }
            }
            return `[${formattedTime}] ${m.transcript}\n`;
        })
        .join("\n") ?? ""}
    bind:modal_open={$content_modal_open}
></GenericContentViewModal>
